import React, { useEffect, useState } from 'react';
import { useParams } from 'react-router-dom';

import './styles.scss';
import { getFutureSpecialGameDetails } from '@racings/api/requests';
import { GetArrayGame } from '@common/helpers/util/swarmTreeDestructuring';
import { Swarm } from '@lbs/swarm-client';
import { DetailsHeader } from './components/detailsHeader';
import { RacingFutureSpecialGame } from './components/racingGame/racingFutureSpecialGame';

const RacingFutureSpecialDetails = ({ routePrefix = '' }) => {
  const { gameId, compId, regionAlias } = useParams();

  const [gameList, setGameList] = useState([]);

  useEffect(() => {
    let subId;
    const swarmInstance = Swarm.getInstance();

    (async () => {
      const { data, subid } = await swarmInstance.subscribe(
        getFutureSpecialGameDetails(+gameId),
        (data) => {
          setGameList(GetArrayGame(data?.game));
        },
        true,
      );
      setGameList(GetArrayGame(data?.game));

      subId = subid;
    })();

    return () => swarmInstance.unsubscribe(subId);
  }, [gameId, compId, regionAlias]);

  return (
    <div className="racing-details-container">
      <DetailsHeader
        routePrefix={routePrefix}
        gameList={gameList}
        competitionName={gameList[0]?.competitionName}
        activeGameId={gameId}
      />
      <div className="games-list">
        {gameList?.map((game) => (
          <RacingFutureSpecialGame
            key={game.id}
            game={game}
            activeGameId={gameId}
            competitionName={game.competitionName}
          />
        ))}
      </div>
    </div>

  );
};

export default RacingFutureSpecialDetails;
